(function ($) {

    let initNav = function () {
        let navSite = $('#nav-site');
        let navSiteSearch = $('#nav-site-search');
        let navLanguages = $('#nav-languages');

        $('.header-site__button').on('click', function () {
            let targetID = $(this).attr('aria-controls');
            let target = $('#' + targetID);
            let isOpen = $(this).attr('aria-expanded');

            if (isOpen === 'true') {
                $(this).attr('aria-expanded', 'false');
                target.removeClass('is-expanded');

                if (targetID === 'nav-site') {
                    $('body').removeClass('has-expanded-nav');
                }
            } else {
                $(this).attr('aria-expanded', 'true');
                target.addClass('is-expanded');
                target.show();

                if (targetID === 'nav-site-search') {
                    $('#nav-site-search__input').focus();
                }

                if (targetID === 'nav-site') {
                    $('body').addClass('has-expanded-nav');
                }
            }
        });

        $('.nav-site__expander').on('click', function () {
            $(this).toggleClass('is-active');
            $(this).siblings('ul').toggle();
        });


        $(document).ready(function () {
            let previousScroll = 0;
            const $header = $('.header-site');
            const $backtotop = $('.back-to-top');
            const headerOrgOffset = $header.offset().top + 100;

            $(window).scroll(function () {
                const currentScroll = $(this).scrollTop();
                if (currentScroll > headerOrgOffset) {
                    if (currentScroll > previousScroll) {
                        $header.fadeOut();
                        $backtotop.removeClass('hide');
                    } else {
                        $header.fadeIn().addClass('fixed');
                    }
                } else {
                    $header.removeClass('fixed');
                    $backtotop.addClass('hide');
                }
                previousScroll = currentScroll;
            });

            $("#back-to-top").on("click", function () {
                window.scrollTo(0, 0);
                $header.fadeIn()
            });
        });

        function closeNavSite() {
            $('#nav-site').removeClass('is-expanded');
            $('#header-site__button--menu').attr('aria-expanded', 'false');
            $('body').removeClass('has-expanded-nav');
        }

        $('#nav-site__close').on('click', function () { closeNavSite(); });
        $(document).on('click', '.nav-site-mask', function () { closeNavSite(); });
        $('#nav-site').on('click', function (e) { e.stopPropagation(); });

        $(document).on('keydown', function (e) {
            if (e.keyCode == keyMap.ESCAPE) { closeNavSite(); }
        });

        $('body').append('<div class="nav-site-mask"></div>');

        $('#nav-secondary__toggle').on('click', function () {
            let targetID = $(this).attr('aria-controls');
            let target = $('#' + targetID);
            let isOpen = $(this).attr('aria-expanded');

            if (isOpen === 'true') {
                $(this).attr('aria-expanded', 'false');
                target.removeClass('is-expanded');
            } else {
                $(this).attr('aria-expanded', 'true');
                target.addClass('is-expanded');
            }
        });
    };

    let keyMap = {
        BACKSPACE: 8, COMMA: 188, DELETE: 46, DOWN: 40, END: 35, ENTER: 13,
        ESCAPE: 27, HOME: 36, LEFT: 37, PAGE_DOWN: 34, PAGE_UP: 33,
        PERIOD: 190, RIGHT: 39, SPACE: 32, TAB: 9, UP: 38,
    };

    let initReadMore = function () {
        $('.js-container-readmore').each(function () {
            let container = $(this);
            container.wrapInner('<div class="js-container-readmore-inner"></div>');
            container.after('<a href="#' + container.attr('id') + '" class="js-toggle-readmore"></a>');

            if (container.height() >= container.find('.js-container-readmore-inner').height()) {
                container.toggleClass('is-open');
                container.next('.js-toggle-readmore').hide();
            }

            $(document).on('click', '.js-toggle-readmore', function (e) {
                e.preventDefault();
                $(this).toggleClass('is-toggled');
                var target = $($(this).attr('href'));

                if (!target.length) {
                    target = $(this).parents('.js-container-readmore');
                }
                target.toggleClass('is-open');
            });
        });
    };

    function renderMap($el) {
        var $markers = $el.find('.marker');

        var mapArgs = {
            zoom: $el.data('zoom') || 16,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            fullscreenControl: true,
            zoomControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            // Ensure you update this ID to your real one from Google Cloud
            mapId: "DEMO_MAP_ID"
        };
        var map = new google.maps.Map($el[0], mapArgs);

        map.markers = [];
        $markers.each(function () {
            initMarker($(this), map);
        });

        centerMap(map);
        return map;
    }

    function initMarker($marker, map) {
        var latLng = {
            lat: parseFloat($marker.data('lat')),
            lng: parseFloat($marker.data('lng'))
        };

        var marker = new google.maps.marker.AdvancedMarkerElement({
            position: latLng,
            map: map
        });

        map.markers.push(marker);

        if ($marker.html()) {
            var infowindow = new google.maps.InfoWindow({ content: $marker.html() });
            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });
        }
    }

    function centerMap(map) {
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function (marker) {
            bounds.extend(marker.position);
        });

        if (map.markers.length == 1) {
            map.setCenter(bounds.getCenter());
        } else {
            map.fitBounds(bounds);
        }
    }

    // THE GLOBAL CALLBACK
    window.initMap = function() {
        $('.acf-map').each(function () {
            renderMap($(this));
        });
    };

    function hashlinks() {
        $('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
            event.preventDefault();
            if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                if (target.length) {
                    event.preventDefault();
                    $('html, body').animate({ scrollTop: target.offset().top }, 10, function () {
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { return false; } else {
                            $target.attr('tabindex', '-1');
                            $target.focus();
                        }
                    });
                }
            }
        });
    }

    function footNotes() {
        $('a[href*="_ftnref"]').each(function () {
            var newUrl = $(this).attr("href").replace("#_ftnref", "_ftn");
            $(this).attr("href", '#up' + newUrl);
            $(this).attr("name", newUrl);
        });
        $('a[href*="#_ftn"]').each(function () {
            var newUrl = $(this).attr("href").replace("#_", "up_");
            $(this).attr("name", newUrl);
        });
    }

    $(document).ready(function () {
        initNav();
        initReadMore();
        footNotes();

        $(".Modern-Slider").slick({
            speed: 200, slidesToShow: 1, slidesToScroll: 1, pauseOnHover: true,
            cssEase: 'linear', autoplay: true, infinite: true, autoplaySpeed: 10000,
            draggable: true, prevArrow: '<button class="PrevArrow"></button>',
            nextArrow: '<button class="NextArrow"></button>',
            responsive: [{ breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: false } }]
        });

        function fetchLocalData() {
            var event = document.querySelector('[id="single-event"]');
            if (!event) return false;
            return {
                'field[26]': event.getAttribute('event-name'),
                'field[25]': event.getAttribute('event-start')
            };
        }

        function replaceFieldValues(newFieldValues) {
            Object.keys(newFieldValues).forEach(function (key) {
                var elem = document.querySelector('[id="' + key + '"]');
                if (elem) elem.value = newFieldValues[key];
            });
        }

        function initACPrePopulation() {
            var newFieldValues = fetchLocalData();
            if (newFieldValues != false) replaceFieldValues(newFieldValues);
        }

        initACPrePopulation();
    });

    $(window).on('load', function () {});

})(jQuery);